var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 251.93 195.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e6141e;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m53,9.4v-.84h5.53v.84h-5.53Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m60.52,9.4v-.84h5.53v.84h-5.53Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m68.03,9.4v-.84h5.53v.84h-5.53Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m75.55,9.4v-.84h5.53v.84h-5.53Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m83.06,9.4v-.84h5.53v.84h-5.53Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m232.96,9.85l5.32-9.47h1.01l-5.3,9.47h-1.02Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m243.19,10.17V0h.91v10.17h-.91Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m62.83,23.43v-10.17h.91v10.17h-.91Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m95.48,23.11l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m143.18,22.67v-.84h5.53v.84h-5.53Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m150.7,22.67v-.84h5.53v.84h-5.53Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m158.21,22.67v-.84h5.53v.84h-5.53Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m165.73,22.67v-.84h5.53v.84h-5.53Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m232.96,23.11l5.32-9.47h1.01l-5.3,9.47h-1.02Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m250.7,23.43v-10.17h.91v10.17h-.91Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m15.43,35.93v-.84h5.53v.84h-5.53Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m22.94,35.93v-.84h5.53v.84h-5.53Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m62.83,36.69v-10.17h.91v10.17h-.91Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m103,36.37l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m135.27,36.37l5.32-9.47h1.01l-5.3,9.47h-1.02Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m148.09,36.37l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m175.55,36.69v-10.17h.91v10.17h-.91Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m225.45,36.37l5.32-9.47h1.01l-5.3,9.47h-1.02Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m250.38,30.3v-1.47h1.55v1.47h-1.55Zm.03,5.92v-.17c.23-.25.4-.51.5-.77.11-.26.16-.53.16-.81h-.62v-1.66h1.4v1.43c0,.36-.06.71-.18,1.05-.12.34-.3.65-.54.92h-.73Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m7.52,49.63l5.32-9.47h1.01l-5.3,9.47h-1.02Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m20.33,49.63l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m42.88,49.63l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m62.83,49.95v-10.17h.91v10.17h-.91Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m110.51,49.63l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m127.75,49.63l5.32-9.47h1.01l-5.3,9.47h-1.02Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m155.6,49.63l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m175.55,49.95v-10.17h.91v10.17h-.91Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m217.93,49.63l5.32-9.47h1.01l-5.3,9.47h-1.02Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m242.87,43.56v-1.47h1.55v1.47h-1.55Zm.03,5.92v-.17c.23-.25.4-.51.5-.77.11-.26.16-.53.16-.81h-.62v-1.66h1.4v1.43c0,.36-.06.71-.18,1.05-.12.34-.3.65-.54.92h-.73Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m0,62.89l5.32-9.47h1.01l-5.3,9.47H0Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m9.94,62.75v-.17c.23-.25.4-.51.5-.77.11-.26.16-.53.16-.81h-.62v-1.66h1.4v1.43c0,.36-.06.71-.18,1.05-.12.34-.3.65-.54.92h-.73Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m17.95,56.52l-.3-1.47v-1.62h1.08v1.62l-.3,1.47h-.49Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m27.85,62.89l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m50.39,62.89l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m62.83,63.21v-10.17h.91v10.17h-.91Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m118.03,62.89l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m120.24,62.89l5.32-9.47h1.01l-5.3,9.47h-1.02Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m145.17,56.83v-1.47h1.55v1.47h-1.55Zm0,4.18v-1.47h1.55v1.47h-1.55Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m163.12,62.89l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m175.55,63.21v-10.17h.91v10.17h-.91Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m210.42,62.89l5.32-9.47h1.01l-5.3,9.47h-1.02Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m242.87,56.83v-1.47h1.55v1.47h-1.55Zm.03,5.92v-.17c.23-.25.4-.51.5-.77.11-.26.16-.53.16-.81h-.62v-1.66h1.4v1.43c0,.36-.06.71-.18,1.05-.12.34-.3.65-.54.92h-.73Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m.04,71.96v-.98c.11-.12.25-.25.43-.39s.38-.24.62-.34c.24-.09.49-.14.75-.14.24,0,.46.04.67.11.21.07.42.16.63.25.21.1.42.18.64.25.22.07.45.11.69.11.27,0,.51-.05.75-.14.23-.09.44-.2.62-.34s.33-.26.43-.39v.98c-.1.12-.25.25-.43.39s-.39.25-.62.34c-.23.09-.48.14-.75.14-.24,0-.46-.04-.67-.11-.21-.07-.42-.16-.63-.25-.21-.1-.42-.18-.64-.25s-.45-.11-.69-.11c-.27,0-.52.05-.75.14-.24.09-.44.21-.62.34-.18.13-.32.26-.43.39Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m24.93,70.09v-1.47h1.55v1.47h-1.55Zm.03,5.92v-.17c.23-.25.4-.51.5-.77.11-.27.16-.53.16-.81h-.62v-1.66h1.4v1.43c0,.36-.06.71-.18,1.06s-.3.65-.54.92h-.73Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m57.91,76.16l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m62.83,76.48v-10.17h.91v10.17h-.91Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m112.72,76.16l5.32-9.47h1.01l-5.3,9.47h-1.02Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m145.17,70.09v-1.47h1.55v1.47h-1.55Zm0,4.18v-1.47h1.55v1.47h-1.55Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m170.63,76.16l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m175.55,76.48v-10.17h.91v10.17h-.91Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m202.9,76.16l5.32-9.47h1.01l-5.3,9.47h-1.02Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m235.35,70.09v-1.47h1.55v1.47h-1.55Zm.03,5.92v-.17c.23-.25.4-.51.5-.77.11-.27.16-.53.16-.81h-.62v-1.66h1.4v1.43c0,.36-.06.71-.18,1.06s-.3.65-.54.92h-.73Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m25.25,89.74v-10.17h.91v10.17h-.91Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m65.42,89.42l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m105.21,89.42l5.32-9.47h1.01l-5.3,9.47h-1.02Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m137.66,83.35v-1.47h1.55v1.47h-1.55Zm0,4.18v-1.47h1.55v1.47h-1.55Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m145.7,83.04l-.3-1.47v-1.62h1.08v1.62l-.3,1.47h-.49Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m168.04,89.74v-10.17h.91v10.17h-.91Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m195.39,89.42l5.32-9.47h1.01l-5.3,9.47h-1.02Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m235.35,83.35v-1.47h1.55v1.47h-1.55Zm.03,5.92v-.17c.23-.25.4-.51.5-.77.11-.27.16-.53.16-.81h-.62v-1.66h1.4v1.43c0,.36-.06.71-.18,1.06s-.3.65-.54.92h-.73Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m25.25,103v-10.17h.91v10.17h-.91Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m72.94,102.68l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m97.69,102.68l5.32-9.47h1.01l-5.3,9.47h-1.02Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m137.66,96.61v-1.47h1.55v1.47h-1.55Zm0,4.18v-1.47h1.55v1.47h-1.55Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m168.04,103v-10.17h.91v10.17h-.91Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m187.87,102.68l5.32-9.47h1.01l-5.3,9.47h-1.02Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m227.84,96.61v-1.47h1.55v1.47h-1.55Zm.03,5.92v-.17c.23-.25.4-.51.5-.77.11-.27.16-.53.16-.81h-.62v-1.66h1.4v1.43c0,.36-.06.71-.18,1.06s-.3.65-.54.92h-.73Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m25.25,116.26v-10.17h.91v10.17h-.91Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m80.45,115.94l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m90.18,115.94l5.32-9.47h1.01l-5.3,9.47h-1.02Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m130.14,109.87v-1.47h1.55v1.47h-1.55Zm0,4.18v-1.47h1.55v1.47h-1.55Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m138.19,109.57l-.3-1.47v-1.62h1.08v1.62l-.3,1.47h-.49Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m168.04,116.26v-10.17h.91v10.17h-.91Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m180.36,115.94l5.32-9.47h1.01l-5.3,9.47h-1.02Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m227.84,109.87v-1.47h1.55v1.47h-1.55Zm.03,5.92v-.17c.23-.25.4-.51.5-.77.11-.26.16-.53.16-.81h-.62v-1.66h1.4v1.43c0,.36-.06.71-.18,1.05-.12.34-.3.65-.54.92h-.73Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m25.25,129.52v-10.17h.91v10.17h-.91Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m82.67,129.2l5.32-9.47h1.01l-5.3,9.47h-1.02Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m130.14,123.14v-1.47h1.55v1.47h-1.55Zm0,4.18v-1.47h1.55v1.47h-1.55Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m168.04,129.52v-10.17h.91v10.17h-.91Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m172.84,129.2l5.32-9.47h1.01l-5.3,9.47h-1.02Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m220.32,123.14v-1.47h1.55v1.47h-1.55Zm.03,5.92v-.17c.23-.25.4-.51.5-.77.11-.26.16-.53.16-.81h-.62v-1.66h1.4v1.43c0,.36-.06.71-.18,1.05-.12.34-.3.65-.54.92h-.73Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m25.25,142.79v-10.17h.91v10.17h-.91Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m75.15,142.47l5.32-9.47h1.01l-5.3,9.47h-1.02Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m122.63,136.4v-1.47h1.55v1.47h-1.55Zm0,4.18v-1.47h1.55v1.47h-1.55Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m130.67,136.09l-.3-1.47v-1.62h1.08v1.62l-.3,1.47h-.49Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m168.04,142.79v-10.17h.91v10.17h-.91Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m220.32,136.4v-1.47h1.55v1.47h-1.55Zm.03,5.92v-.17c.23-.25.4-.51.5-.77.11-.27.16-.53.16-.81h-.62v-1.66h1.4v1.43c0,.36-.06.71-.18,1.06s-.3.65-.54.92h-.73Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m35.36,155.73l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m67.63,155.73l5.32-9.47h1.01l-5.3,9.47h-1.02Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m122.63,149.66v-1.47h1.55v1.47h-1.55Zm0,4.18v-1.47h1.55v1.47h-1.55Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m168.04,156.05v-10.17h.91v10.17h-.91Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m212.81,149.66v-1.47h1.55v1.47h-1.55Zm.03,5.92v-.17c.23-.25.4-.51.5-.77.11-.27.16-.53.16-.81h-.62v-1.66h1.4v1.43c0,.36-.06.71-.18,1.06s-.3.65-.54.92h-.73Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m42.88,168.99l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m60.12,168.99l5.32-9.47h1.01l-5.3,9.47h-1.02Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m115.11,162.92v-1.47h1.55v1.47h-1.55Zm0,4.18v-1.47h1.55v1.47h-1.55Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m123.16,162.61l-.3-1.47v-1.62h1.08v1.62l-.3,1.47h-.49Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m168.04,169.31v-10.17h.91v10.17h-.91Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m212.81,162.92v-1.47h1.55v1.47h-1.55Zm.03,5.92v-.17c.23-.25.4-.51.5-.77.11-.27.16-.53.16-.81h-.62v-1.66h1.4v1.43c0,.36-.06.71-.18,1.06s-.3.65-.54.92h-.73Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m50.39,182.25l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m107.6,176.18v-1.47h1.55v1.47h-1.55Zm0,4.18v-1.47h1.55v1.47h-1.55Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m115.64,175.88l-.3-1.47v-1.62h1.08v1.62l-.3,1.47h-.49Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m168.04,182.57v-10.17h.91v10.17h-.91Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m205.29,176.18v-1.47h1.55v1.47h-1.55Zm.03,5.92v-.17c.23-.25.4-.51.5-.77.11-.26.16-.53.16-.81h-.62v-1.66h1.4v1.43c0,.36-.06.71-.18,1.05-.12.34-.3.65-.54.92h-.73Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m57.91,195.51l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m60.52,195.07v-.84h5.53v.84h-5.53Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m68.03,195.07v-.84h5.53v.84h-5.53Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m75.55,195.07v-.84h5.53v.84h-5.53Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m83.06,195.07v-.84h5.53v.84h-5.53Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m90.58,195.07v-.84h5.53v.84h-5.53Z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m98.09,195.07v-.84h5.53v.84h-5.53Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m107.6,189.45v-1.47h1.55v1.47h-1.55Zm0,4.18v-1.47h1.55v1.47h-1.55Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m113.12,195.07v-.84h5.53v.84h-5.53Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m120.64,195.07v-.84h5.53v.84h-5.53Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m128.15,195.07v-.84h5.53v.84h-5.53Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m135.67,195.07v-.84h5.53v.84h-5.53Z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m143.18,195.07v-.84h5.53v.84h-5.53Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m150.7,195.07v-.84h5.53v.84h-5.53Z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m158.21,195.07v-.84h5.53v.84h-5.53Z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m168.04,195.83v-10.17h.91v10.17h-.91Z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m173.24,195.07v-.84h5.53v.84h-5.53Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m180.76,195.07v-.84h5.53v.84h-5.53Z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m188.27,195.07v-.84h5.53v.84h-5.53Z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m197.78,189.45v-1.47h1.55v1.47h-1.55Zm.03,5.92v-.17c.23-.25.4-.51.5-.77.11-.26.16-.53.16-.81h-.62v-1.66h1.4v1.43c0,.36-.06.71-.18,1.05-.12.34-.3.65-.54.92h-.73Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.aa08101973bd1a8061ddf273043146b4.svg";
export { ForwardRef as ReactComponent };